import { notification } from "antd";

export const convertStringToCurrentProtocol = (url: string):string => {
  let str = url;
  if (window.location.protocol === 'https:' && /^http:/.test(str)) { str = str.replace(/^http:/, 'https:'); }
  return str;
};

export const successNotification = (msg: string) => {
  notification.success({
    message: msg,
    placement: 'topRight',
  })
}